// extracted by mini-css-extract-plugin
export default {"tab-header":"components-DocumentUploads-__styles__-Tabs-module__tab-header","tab-body":"components-DocumentUploads-__styles__-Tabs-module__tab-body"};